import React from 'react';
import jet from "@randajan/jet-core";
import { list } from '@randajan/jet-core/eachSync';

import { Block } from '@randajan/jet-react/dom/block';
import { Caption } from '@randajan/jet-react/dom/caption';
import { usePop } from '@randajan/jet-react/dom/modal';
import { Button, Field, Form, Range } from '@randajan/jet-react/dom/form';

import formsSchema from '../../../arc/forms/formsSchema';

import "./Apiform.scss";
import { Rating } from '../Rating/Rating';
import { bifrost } from '../../config/bifrost';

const ApiError = (props)=>{
    console.log(props);
    return (
        <Block caption="Ajaj...">
            <p>Omlouváme se, ale <span title={props?.error?.message}>něco</span> se nepovedlo</p>
            <p>Zkuste to prosím později</p>
        </Block>
    )
}

export const Apiform = (props) => {
    const { className, caption, name, submit, rawput, afterDone, children, note } = props;
    const pop = usePop();

    return (
        <Form className={jet.melt(["Apiform", className], " ")} flags={{ focus: f => f.getFocus() }} rawput={rawput}>
            <div className="header">
                <Caption>{caption}</Caption>
            </div>
            <div className="fields">
                {list(formsSchema[name].fields, (field, {key:name}) => {
                    const p = Object.jet.extract(field, ["label", "type", "hidden"]);

                    p.key = p.name = name;
                    if (p.hidden) { return <Field {...p} className={"hidden"} lock />; }
                    if (p.type === "textarea") { p.rows = 3; p.autoSize = true; }
                    if (p.type !== "number") { p.maxLength = field.max; }
                    if (name === "rating") {
                        return <Range {...p} from={field.min} to={field.max} step={10} marker={<Rating />} />
                    }
                    return <Field {...p} />
                })}
            </div>
            <div className="note">{note}</div>
            <div className="buttons">
                <Button type="submit" onSubmit={async btn => {
                    const form = btn.props.parent;
                    const body = form.getOutput();

                    let result;
                    try { result = await bifrost.tx("sunPost", {formName:name, body}); }
                    catch (error) {
                        const { message } = error;
                        result = { isDone:false, code:500, error:{ message } }
                    }

                    pop.up({
                        children:<div className="ApiResponse">{result?.isDone ? children : <ApiError {...result}/>}</div>,
                        onDown:_=>{ if (result.isDone) { form.reset(); jet.run(afterDone); } }
                    });
                    
                }}>{String.jet.only(submit, "Odeslat")}</Button>
            </div>
        </Form>
    );
}